import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnChanges, OnDestroy } from '@angular/core';
import { BarControllerDatasetOptions, ChartConfiguration } from 'chart.js/auto';
import { Icons } from '../../icon/constants/icons.constants';
import { IconComponent } from '../../icon/icon.component';
import { LogoLoadingComponent } from '../../logo-loading/logo-loading.component';
import { BaseChartComponent } from '../base/base-chart.component';
import { COLORS } from '../constants/chart.constants';

@Component({
    selector: 'nw-bar-chart',
    templateUrl: '../base/base-chart.component.html',
    styleUrl: '../base/base-chart.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, LogoLoadingComponent, IconComponent],
    host: {
        class: 'chart__container'
    }
})
export class BarChartComponent
    extends BaseChartComponent<'bar', BarControllerDatasetOptions>
    implements OnDestroy, OnChanges
{
    public override icon: Icons.Type = Icons.Charts.column;

    public override datasetDefaults = (
        index: number
    ): Partial<BarControllerDatasetOptions> => {
        return {
            borderColor: COLORS[index % COLORS.length],
            backgroundColor: COLORS[index % COLORS.length],
            borderWidth: 1,
            borderRadius: 1,
            borderSkipped: false
        };
    };

    public override configDefaults(): Partial<ChartConfiguration> {
        return {
            type: 'bar',
            options: {
                scales: {
                    x: {
                        grid: {
                            display: false
                        },
                        ticks: { display: false },
                        border: {
                            color: this.theme === 'dark' ? '#787f87' : '#f1f2f3'
                        }
                    },
                    y: {
                        grid: {
                            display: false
                        },
                        ticks: { display: false },
                        border: {
                            color: this.theme === 'dark' ? '#787f87' : '#f1f2f3'
                        }
                    }
                }
            }
        };
    }
}
